import { render, staticRenderFns } from "./ApprovalList.vue?vue&type=template&id=3f7ba5bc&scoped=true&"
import script from "./ApprovalList.vue?vue&type=script&lang=ts&"
export * from "./ApprovalList.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovalList.vue?vue&type=style&index=0&id=3f7ba5bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7ba5bc",
  null
  
)

export default component.exports